import { __read } from "tslib";
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useEffect, useState } from 'react';
export var useSystemHighContrastTheme = function () {
    var _a, _b;
    var featureGates = useFeatureGates().data;
    var _c = __read(useState(false), 2), isHighContrast = _c[0], setIsHighContrast = _c[1];
    useEffect(function () {
        var _a, _b;
        var isSystemThemeEnabled = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.m365SystemThemeGates) === null || _b === void 0 ? void 0 : _b.m365SystemThemeEnabled;
        if (!isSystemThemeEnabled) {
            return;
        }
        var mediaQuery = window.matchMedia('(forced-colors: active)');
        var handleChange = function () {
            setIsHighContrast(mediaQuery.matches);
        };
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
        return function () {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [(_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.m365SystemThemeGates) === null || _b === void 0 ? void 0 : _b.m365SystemThemeEnabled]);
    return isHighContrast;
};
//# sourceMappingURL=useSystemTheming.js.map